import React from 'react';
import CheckInForm from './CheckInForm';

export default function CheckInHero() {
  return <CheckInForm />;
}